module.exports = __webpack_public_path__ + "4900e07315e0d2f31d42310a4764eb89.png";